<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                   
                    <v-card elevation="1" class="mt-3 pa-5" >
                       <h3>Basic Info</h3>
                       <v-simple-table>
                           <tbody>
                            <tr>
                                <!--
                                <th class="listHeader tableLinerT" style="width:20%">National</th>
                                <td class="tableLinerT text-left pl-5">{{COUNTRY_INFO}}</td>
                                -->
                                <th class="listHeader tableLinerT" style="width:20%">Chager Station Name</th>
                                <td class="tableLinerT text-left pl-5" colspan="3">{{BSS_NM}}</td>
                            </tr>
                           <tr>
                               <th class="listHeader">Address</th>
                               <td class="text-left pl-5" colspan="3">{{POST}} {{ADDR1}} {{ADDR2}} </td>
                           </tr>
                           <tr>
                               <th class="listHeader">Latitude / Longitude</th>
                               <td class="text-left pl-5" colspan="3">
                                   <div class="d-flex flat ">
                                        <div class="mr-3 align-self-center" style="">
                                            {{LATITUDE}} / {{LONGITUDE}}
                                        </div>
                                        <div class="mr-3 align-self-center">
                                            <v-btn icon @click="mapOpenToggle" :color="mapOpenColor"><v-icon>mdi-map-marker-radius</v-icon></v-btn>
                                        </div>
                                    </div>
                                </td>
                           </tr>                           
                           <tr>
                               <th class="listHeader">Agency</th>
                               <td class="text-left pl-5">{{AGENCY_INFO}}</td>
                               <th class="listHeader">Status</th>
                               <td class="text-left pl-5">{{APRV_INFO}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader">Registration User</th>
                               <td class="text-left pl-5">{{INS_USR_ID}}</td>
                               <th class="listHeader">Approval User</th>
                               <td class="text-left pl-5">{{APRV_USR_ID}}</td>
                           </tr>
                           <tr>
                               <th class="listHeader tableLinerB">Registration Date</th>
                               <td class="tableLinerB text-left pl-5" colspan="3">{{INS_DTM}}</td>
                           </tr>
                           </tbody>
                        </v-simple-table>

                        <h3 class="ma-0 pa-0 mt-5" >Charger &amp; Battery Info</h3>
                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <thead>
                                <tr class="listHeader">
                                    <th class="listHeader tableLinerT">No</th>
                                    <th class="listHeader tableLinerT" >Charger(model)</th>
                                    <th class="listHeader tableLinerT" >Battery1 & SOC(%)</th>
                                    <th class="listHeader tableLinerT" >Battery2 & SOC(%)</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr style="height:43px;">
                                <th class="listHeader tableLinerR tableLinerT" style="width:5%">1</th>
                                <td class="tableLinerT text-center " style="width:20%">
                                    {{CHRG_ID}} ({{CHRG_MODEL}})
                                </td>
                                <td class="tableLinerT text-center " style="width:21%">
                                    <span :style="{'color':CELL_COLOR1}">{{CELL_ID1}} 
                                    <span v-if="CELL_ID1 !==null && CELL_ID1 !=='' && CELL_ID1 !=='empty'">({{ CELL_CHRG_GAGE1 }}%)</span>
                                   
                                    </span>
                                </td>
                                <td class="tableLinerT text-center " style="width:21%">
                                    <span :style="{'color':CELL_COLOR2}">{{CELL_ID2}}
                                        <span v-if="CELL_ID2 !==null && CELL_ID2 !=='' && CELL_ID2 !=='empty'">({{ CELL_CHRG_GAGE2 }}%)</span>
                                       
                                    </span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5" v-if="mapOpenFlag" >
                        <div class="align-self-center"><h3>Map</h3></div>
                        <GmapMap :zoom="14" :center="center" style="width:100%; height:300px;">
                            <GmapMarker :position="marker.position" :clickable="true" :draggable="true"/>
                        </GmapMap>
                    </v-card>

                    <v-card elevation="1" class="mt-3 pa-5" >
                        <div class="d-flex flat ">
                            <div class="mr-auto align-self-center"><h3>History</h3></div>
                            <div ><v-btn icon color="primary" @click="regOpenHistory"><v-icon>mdi-pencil-plus</v-icon></v-btn></div>
                        </div>
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader text-center" style="width:20%;">Date</th>
                                    <th class="listHeader tableLinerR text-center">Memo</th>
                                </tr>
                                <tr v-for="(item) in historyList" :key="item.HIS_SEQ">
                                    <td class="rowList tableLinerR tableLinerB">{{item.INS_DTM}}</td>
                                    <td class="rowList tableLinerB text-left pl-5">{{item.CONT}}</td>
                                </tr>
                                <tr v-if="emptyHistoryFlag==true">
                                    <td colspan="11" class="tableLinerB" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                        <div class="pa2 my-5">
                            <div>
                                <div class="text-center">
                                    <v-pagination
                                    v-model="page"
                                    :length="pagelength"
                                    ></v-pagination>
                                </div>
                            </div>
                        </div>

                            <div class="d-flex justify-space-between dense pa-0">
                                <div class="pa2 " >
                                <v-btn dark class="backBtn px-5" @click="goBack" >Back</v-btn>
                            </div>
                            
                            <div class="pa2 ">
                                <v-btn v-if="DEL_FLAG=='Y'" dark class="deleteBtn ml-2 px-5" @click="delconfirm=true">Delete</v-btn>
                                <v-btn dark class="registerBtn ml-2 px-6" @click="editInfo()">Edit</v-btn>
                            </div>
                            </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <div class="text-center pb-0 mb-0" >
            <v-form ref="form" v-model="formValid" lazy-validation>
            <v-dialog v-model="historyRegFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-3">
                       
                        <span>History Register</span>
                    </v-card-title>
                    <v-card-text class="pb-0">
                        <v-simple-table>
                            <tbody>
                                <tr>
                                    <th class="listHeader2 tableLinerT tableLinerB text-center" style="width:30%;height:40px !important;">작성자</th>
                                    <td class="tableLinerT text-left pl-5" style="height:40px !important;">admin</td>
                                </tr>
                                <tr>
                                    <th class="listHeader2 tableLinerT tableLinerB text-center" style="height:40px !important;">작성일</th>
                                    <td class="text-left pl-5" style="height:30px !important;">{{today}}</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class=" tableLinerB">
                                        <v-textarea
                                        outlined
                                        v-model="histroyCont"
                                        :rules="historyContRules"
                                        class="py-5"
                                        :counter="max"
                                        no-resize
                                        required
                                        ></v-textarea>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </v-card-text>
                    <v-card-actions class="justify-end py-5 pr-10">
                        <v-btn color="red lighten-2" style="color:#fff"  @click="closeHistoryDialog">cancel</v-btn>
                        <v-btn color="primary"  @click="addHistory()">save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            </v-form>
        </div>

        <!--asyncSuccess-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="goBack">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="asyncErrors=false;">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--confirm delete-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="delconfirm" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:red;'>mdi-help-circle </v-icon>
                        <span class="pl-3">Do you want to delete vehicle?</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn class="deleteBtn" text dark @click="delconfirm=false">no</v-btn>
                        <v-btn class="registerBtn" text dark  @click="delInfo">yes</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

    </div>
</template>



<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
    .tableLinerR {border-right:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerB {border-bottom:1px solid rgb(0, 0, 0, 0.12)}
    .tableLinerT {border-top:1px solid rgb(0, 0, 0, 0.12)}
    tbody tr:hover { background-color: transparent !important; }
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'

export default {
    name: 'BssDetail',
    components: { Gnb, Footer, PageCrumbs,  Navs, },

    data () {
        return {
             // login Info
            gnbCode:"3", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:1, navCode2:11, 
            // Page Title & Breadcrumbs
            pTitles: "Detail",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'BSS', disabled: true,}, { text: 'BSS Management', disabled: true,}, { text: 'BSS & Charger List', disabled: false,}],
            NavList: [ 
                        { title: 'BSS & Charger Management', nums: '1',
                            items: [ { title: 'BSS & Charger List', nums:11, href:'/Bss' , icons:'mdi-format-list-bulleted' },{ title: 'New Registration', nums:12, href:'/BssWrite', icons:'mdi-lead-pencil' },],
                        },
                        { title: 'Charger Log', nums: '2',
                            items: [ { title: 'Charger Log',nums:21, href:'/BssLog', icons:'mdi-format-list-bulleted' },],
                        },
                    ],     

            // Summery title & Count
            scnt1:"0", scnt2:"0", scnt3:"0", scnt4:"0", summeryTtile:"등록현황", summeryTtile1:"VCU", summeryTtile2:"MCU", summeryTtile3:"BMS", summeryTtile4:"Charger",

            schSeq:'', schCls:'',
            COUNTRY_CODE: "", COUNTRY_INFO: "",
            AGENCY_SEQ: "", AGENCY_INFO: "", BSS_NM: "", ADDR1: "",
            ADDR2: "", POST: "",
            LATITUDE: "", LONGITUDE: "", BSS_STATUS: "",
            APRV_STATUS: "", APRV_INFO: "",APRV_USR_ID: "", APRV_USR: "", APRV_DTM: "",
            INS_DTM:"", INS_USR_ID:"", INS_USR:"",
            CHRG_MODEL: "", CHRG_ID:"", CELL_IDS:"", CELL_ID1:"", CELL_ID2:"", CELL_CHRG_GAGE1:"", CELL_CHRG_GAGE2:"",
            CELL_COLOR1:"", CELL_COLOR2:"",  DEL_FLAG:"N",

            page:1, pagelength:1,
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false,
            today: new Date().toISOString().substr(0, 10),
            histroyCont:"",
            emptyFlag:true,emptyHistoryFlag:true,historyRegFlag:false, historyList:[],
            historyContRules: [
                v => !!v || 'content is required',
                v => v.length <= 100 || 'content must be less than 100 characters',
                
            ],
            max:100, formValid:false,
            center: { lat: 10, lng: 10 },
            marker: { position: { lat: 10, lng: 10 } },

            mapOpenFlag:true, mapOpenColor:"primary", delconfirm:false
            
        }
    },

    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {

        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        //console.log('param 확인' + this.$route.params.Seq +" / "+ this.$route.params.ChrgID);
        this.schSeq = this.$route.params.Seq; 
        this.schChrgID = this.$route.params.ChrgID;
        if(this.schSeq == '' || this.schSeq == undefined || this.schChrgID == '' || this.schChrgID == undefined) {
            this.schSeq = localStorage.getItem("schBssSeq");
            this.schChrgID = localStorage.getItem("schBssChrgID");
        } 
        if(this.schSeq != '' && this.schChrgID != '') {
            this.getInfo();
            this.getHistory();
        } else {
            alert("Not Data");
            this.$router.replace('Bss');
        }
        window.scrollTo(0, 0);
    },

    methods : {
    
        // API Async 
        getInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "R"
                    , "bssSeq": this.schSeq
                    , "chrgID": this.schChrgID
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "R"
                    , "bssSeq": this.schSeq
                    , "chrgID": this.schChrgID
                }));
            */
            var apiURL = 'https://api.e3bss.com/_APP/POC/bssInfo.php'; 
                        
            fetch(apiURL, requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                console.log(json);
                if(json.result == "success") {

                    this.COUNTRY_CODE = json.COUNTRY_CODE; this.COUNTRY_INFO = json.COUNTRY_INFO; this.AGENCY_SEQ = json.AGENCY_SEQ; 
                    this.AGENCY_INFO = json.AGENCY_INFO;
                    this.BSS_NM = json.BSS_NM; this.ADDR1 = json.ADDR1; this.ADDR2 = json.ADDR2; 
                    this.POST = json.POST; this.LATITUDE = json.LATITUDE; 
                    this.LONGITUDE = json.LONGITUDE;

                    this.center.lat = Number(json.LATITUDE);
                    this.center.lng = Number(json.LONGITUDE);
                    this.marker.position.lat = Number(json.LATITUDE);
                    this.marker.position.lng = Number(json.LONGITUDE);
      
                    this.BSS_STATUS = json.BSS_STATUS;
                    
                    this.CHRG_MODEL = json.CHRG_MODEL;
                    this.CHRG_ID = json.CHRG_ID;
                    this.CELL_IDS = json.CELL_IDS;
                    if(json.CELL_ID1!='') {
                        this.CELL_ID1 = json.CELL_ID1;
                    } else {
                        this.CELL_ID1 = "empty";
                        this.CELL_COLOR1 = "#3F51B5";
                    }
                    if(json.CELL_ID2!='') {
                        this.CELL_ID2 = json.CELL_ID2;
                    } else {
                        this.CELL_ID2 = "empty";
                        this.CELL_COLOR2 = "#3F51B5";
                    }

                    this.CELL_CHRG_GAGE1 = json.CELL_CHRG_GAGE1; this.CELL_CHRG_GAGE2 = json.CELL_CHRG_GAGE2; 
                    
                    this.APRV_STATUS = json.APRV_STATUS; this.APRV_INFO = json.APRV_INFO;
                    this.APRV_USR_ID = json.APRV_USR_ID; this.APRV_USR = json.APRV_USR; 
                    this.APRV_DTM = json.APRV_DTM;

                    this.INS_DTM = json.INS_DTM; this.INS_USR_ID = json.INS_USR_ID; this.INS_USR = json.INS_USR;
                    this.DEL_FLAG = json.DEL_FLAG;
                    this.emptyFlag = false;

                } else {
                   
                    this.emptyFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },
        
        regOpenHistory() {
            this.histroyCont = "";
            this.historyRegFlag = true;
        },

        getHistory() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "dvcSeq": this.schSeq
                    , "dvcType": this.schCls
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.historyList = json.list;
              
                    this.emptyHistoryFlag = false;
                } else {
                   this.historyList = [];
                    this.emptyHistoryFlag = true;
                    
                }
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        },

        addHistory() {
            this.validate();
            if( this.histroyCont == "" || this.histroyCont < 10 || this.histroyCont.length > 100 ) {
                alert('Please enter more than 10 characters and less than 100 characters');
                this.formValid = false;
            }
            
            //console.log(this.formValid);
            
            if(this.formValid === true) {
                var  requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ "usrID": this.loginInfo1
                        , "authCode": this.loginInfo3
                        , "act": "C"
                        , "dvcSeq": this.schSeq
                        , "cont": this.histroyCont
                        , "dvcType": this.schCls
                    })
                };
                
                fetch('https://api.e3bss.com/_APP/POC/shareHistory.php', requestOptions)
                .then((response) => {
                    if(response.ok) {
                        return response.json();
                    }
                    throw new Error('Network response was not ok');
                }).then((json) => {
                    //console.log(json.result );
                    if(json.result == "success") {
                        this.getHistory();
                        this.histroyCont = '';
                        this.historyRegFlag = false;
                    } 
                }).catch(() => {
                    //console.log(error);
                    this.$router.replace('Error');
                });
            } else {
                this.resetValidation();
            }
            
        },
        validate () {
            //alert('a');
            this.$refs.form.validate();
        },
        resetValidation () {
            //alert('b');
            this.$refs.form.resetValidation();
        },
        closeHistoryDialog() {
            this.histroyCont = "";
            this.historyRegFlag = false;
        },

        // temp : child Error Component
        closeErrorDialog() {
            this.histroyCont = "";
            this.asyncErrors = false;
        },

        // back button
        goBack() {
            //console.log('back');
            //return this.$router.go(-1);
            this.$router.push({ name: 'Bss'});
        },

        editInfo() {
            //this.schSeq != '' && this.schCls
            this.$router.push({ name: 'BssWrite', params: { Seq: this.schSeq, ChrgID: this.schChrgID }})
        },

        mapOpenToggle() {
            if(this.mapOpenFlag) {
                this.mapOpenFlag = false;
                this.mapOpenColor="primary";
            } else {
                this.mapOpenFlag = true;
                this.mapOpenColor="grey";
            }
        },
        delInfo() {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "D"
                    , "bssSeq": this.schSeq
                    
                })
            };
            
            fetch('https://api.e3bss.com/_APP/POC/bssInfo.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                //console.log(json.result );
                if(json.result == "success") {
                    this.delconfirm = false;
                    this.asyncSuccess = true;
                    this.asyncErrors = false;
                } else {
                    this.asyncResult = 1;
                    this.asyncSuccess = false;
                    this.asyncErrors = true;
                }
                //console.log("asyncResult: "+this.asyncResult);
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        }


    }

}
</script>
